import React, { Component } from "react";
import InputForm from "./InputForm";
import axios from "axios";
import { Button, Col, Tooltip } from 'antd';


class PessoaFrame extends Component {
    state = {
        lista: [],
        codigo: {
            key: '0',
            label: '',
        },
        buscando: false,
    }

    componentDidUpdate(propsAnterior, stateAnterior) {
        if (this.state.codigo.key !== this.props.value.key) {
            this.setState({
                codigo: {
                    key: this.props.value.key,
                    label: '',
                },
                lista: [{
                    key: '0',
                    label: ((this.props.descricaoPrimeiroItem) && (this.props.descricaoPrimeiroItem !== '')) ? this.props.descricaoPrimeiroItem : 'Todos',
                }, {
                    key: this.props.value.key,
                    label: this.props.value.label,
                }]
            })
        }
    }

    componentDidMount() {
        // this.getListaRegistros();
    }

    getListaRegistros = (value) => {
        this.setState({ lista: [] })

        clearTimeout(this.buscaRegistrosId);
        this.buscaRegistrosId = setTimeout(() => {
            this.setState({ buscando: true });

            axios.get('/pessoas/lista', {
                params: {
                    nome: value,
                    situacao: 'A',
                    ehCodigo: ((value) && (parseInt(value)) && (value.length <= 6)) ? 1 : 0,
                    tipo: this.props.tipo
                }
            }).then(response => {
                const { data } = response;
                const lista = data.map(regList => {
                    return {
                        key: regList.pes_idf,
                        label: regList.pes_nome + ' [' + regList.pes_codigo + '] ' + (regList.pes_cpf_cnpj !== '' ? ' [' + regList.pes_cpf_cnpj + '] ' : ''),
                        cliente: regList.pes_cliente,
                        fornec: regList.pes_fornecedor,
                        pes_ind_ie: regList.pes_ind_ie,
                        cuf_codigo: regList.cuf_codigo,
                        cuf_sigla: regList.cuf_sigla,
                    }
                });

                if ((value) && (parseInt(value)) && (value.length <= 6) && (lista.length = 1)) {
                    // console.log('getListaRegistros: ', lista);

                    const value = {
                        key: String(lista[0].key),
                        label: lista[0].label,
                        cliente: lista[0].cliente,
                        fornec: lista[0].fornec,
                        pes_ind_ie: lista[0].pes_ind_ie,
                        cuf_codigo: lista[0].cuf_codigo,
                        cuf_sigla: lista[0].cuf_sigla,
                    };
                    this.setState({
                        [this.props.id]: value,
                        codigo: value,
                        cliente: lista[0].cliente,
                        fornec: lista[0].fornec,
                        pes_ind_ie: lista[0].pes_ind_ie,
                        cuf_codigo: lista[0].cuf_codigo,
                        cuf_sigla: lista[0].cuf_sigla,
                    });
                    const state = {};
                    state[this.props.id] = value;
                    this.props.onChange(state);

                } else {
                    if ((this.props.descricaoPrimeiroItem) && (this.props.descricaoPrimeiroItem !== '')) {
                        lista.unshift({ key: '0', label: this.props.descricaoPrimeiroItem });
                    }
                }

                this.setState({
                    lista,
                    buscando: false,
                })
            }).catch(error => {
                console.error(error.response);
                this.setState({
                    lista: [],
                    buscando: false,
                })
            })
        }, 1000);
    };

    onChange = event => {
        // console.log('PessoaFrame onChange : ', event);
        const value = event.target.value;
        const id = event.target.id;
        const state = {};
        const iInd = this.state.lista.findIndex(registro => String(registro.key) === String(value.key));
        state[id] = {
            key: value.key,
            label: value.label,
            codigo: value,
            cliente: this.state.lista[iInd].cliente,
            fornec: this.state.lista[iInd].fornec,
            pes_ind_ie: this.state.lista[iInd].pes_ind_ie,
            cuf_codigo: this.state.lista[iInd].cuf_codigo,
            cuf_sigla: this.state.lista[iInd].cuf_sigla,
        };
        this.props.onChange(state);
    };



    render() {
        const { label, id, width, disabled } = this.props;
        const { lista, codigo, buscando } = this.state;

        // console.log('PessoaFrame - this.props: ', this.props);
        // console.log('PessoaFrame - this.state: ', this.state);

        return (
            <span style={{}}>
                <div>{label}</div>
                <InputForm
                    type="select"
                    id={id}
                    ref={id}
                    value={codigo}
                    onChange={this.onChange}
                    data={lista}
                    validator={value => Boolean(value)}
                    onSearch={this.getListaRegistros}
                    fetching={buscando}
                    showArrow={false}
                    filterOption={false}
                    notFoundContent={null}
                    defaultActiveFirstOption={false}
                    showSearch
                    style={{ width: width }}
                    disabled={disabled ? true : false}
                    placeholder="Digite o Nome"
                />
                <div style={{ float: "right", margin: 0, padding: 0, marginTop: -63 }}>
                    <Tooltip title="Carregar Todos">
                        <Button
                            type="ghost"
                            icon="reload"
                            onClick={() => this.getListaRegistros('')}
                            style={{ color: 'rgba(0,0,0,0.4)', fontSize: 20, marginTop: 4, marginLeft: -39, borderWidth: 0 }}
                        />
                    </Tooltip>
                </div>
            </span>
        );
    }
}

export default PessoaFrame;



// WEBPACK FOOTER //
// ./src/components/PessoaFrame.js